// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"4f50beb7","96":"abe0f668","345":"d7c6df72","447":"d1702dcb","636":"696f3158"}[chunkId] + ".chunk.css";
};